import clsx from "clsx";
import React from "react";
import { IconSortDown, IconSortUp } from "~/components/Iconfont/Iconfont";
import { ColumnSortType } from "~/pages/constants";

type SortedColumnHeadProps = {
    label: string;
    sort: ColumnSortType;
    onClick: (nextSort: ColumnSortType) => void;
};

const SortedColumnHead: React.FC<SortedColumnHeadProps> = ({
    label,
    sort,
    onClick,
}) => {
    const handleClick = () => {
        if (sort === ColumnSortType.Descending) {
            return onClick(ColumnSortType.Ascending);
        } else if (sort === ColumnSortType.Ascending) {
            return onClick(ColumnSortType.None);
        } else {
            return onClick(ColumnSortType.Descending);
        }
    };

    return (
        <div className="flex items-center cursor-pointer" onClick={handleClick}>
            <span className="text-text_3 text-direction1">{label}</span>
            <div className="ml-[2px] flex flex-col items-center justify-center">
                <IconSortUp
                    className={clsx(
                        "text-[8px]",
                        sort === ColumnSortType.Ascending
                            ? "!text-text_1"
                            : "!text-text_3"
                    )}
                />
                <IconSortDown
                    className={clsx(
                        "text-[8px]",
                        sort === ColumnSortType.Descending
                            ? "!text-text_1"
                            : "!text-text_3"
                    )}
                />
            </div>
        </div>
    );
};

export default React.memo(SortedColumnHead);
